import React from "react";
import { createRoot } from 'react-dom/client';
import { App } from "./App";
import { BrowserRouter } from 'react-router-dom';
import {Provider} from 'react-redux';
import {store} from './_store';
import SimpleReactLightbox from "simple-react-lightbox";
import ThemeContext from "./context/ThemeContext"; 


const container = document.getElementById('root');
const root = createRoot(container);

root.render(
	// <React.StrictMode>
		<Provider store = {store}>
             <SimpleReactLightbox> 
                <BrowserRouter>
                   <ThemeContext>
                        <App />
                  </ThemeContext>  
                </BrowserRouter>    
            </SimpleReactLightbox> 
        </Provider>	
	// </React.StrictMode>
);

